import * as $ from 'jquery';
import 'MagnificPopup';

export class QRcodeGame{
    private validity:Array<boolean> = [false,false, false, false];
    private mob: any;
    init():void{
        this.mob = this.getCookie('qrc-id');
        if(this.mob){
            $('#submit-collect').click();
            
        }
        else{
            $("#general-popup button").text($("#welcome #qrcode-scan-initialpopup").val());
            this.createPopup($("#welcome"),function(){
                $("#general-popup button").text("Okay");
            });
            $('#point-collection-form, #registration-form, #info-section').show();
            $("#qrcode-game-content").show();
            $("#loader").hide();
            this.initInputs();
            this.navigateToRegister();
    }
    }

    initInputs(): void{
        let _self = this;
        $(scope).find('input').each(function(){
            $(this).focus(function(){
                $(this).parent('.input-control').addClass('input-filled');
                $(this).next().hide();
            })
            .on('change blur',function(){
                if($(this).val()===''){
                    $(this).parent('.input-control').removeClass('input-filled');
                }
                if($('#point-collection-form:visible').length == 0){
                    if(_self.handleRegistrationValidation($(this),'change') ){
                        $('#submit-register').removeClass('disabled');
                    }
                    else{
                        $('#submit-register').addClass('disabled');
                    }
                }else{
                    let elm = $('#mob-collect');
                    if(elm.val()==='' || !/\d{10,11}/.test(elm[0].value)){
                        elm.next().show();
                        $('#submit-collect').addClass('disabled');
                    }else{
                        $('#submit-collect').removeClass('disabled');
                    }
                }

            })
            .keyup(function(){
                if($('#point-collection-form:visible').length == 0){
                    if(_self.handleRegistrationValidation($(this),'keyup') ){
                        $('#submit-register').removeClass('disabled');
                    }
                    else{
                        $('#submit-register').addClass('disabled');
                    }
                }else{
                    let elm = $('#mob-collect');
                    if(elm.val()==='' || !/\d{10,11}/.test(elm[0].value)){
                        $('#submit-collect').addClass('disabled');
                    }else{
                        $('#submit-collect').removeClass('disabled');
                    }
                }
            })

        })
        
    }
    handleRegistrationValidation(elm:any, event: string):boolean{
        let _self = this;
            switch (elm.attr('name')){
                case 'user-name':
                    if(elm.val()===''){
                        if(event==='change'){elm.next().show();}
                        _self.validity[0]=false;
                    }
                    else{
                        _self.validity[0]=true;
                    }
                    break;
                case 'user-email':
                    if(elm.val()==='' || !elm[0].checkValidity()){
                        if(event==='change'){elm.next().show();}
                        _self.validity[1]=false;
                    }
                    else{
                        _self.validity[1]=true;
                    }
                    break;
                case 'mob-register':
                    if(elm.val()==='' || !/\d{10,11}/.test(elm[0].value)){
                        if(event==='change'){elm.next().show();}
                        _self.validity[2]=false;
                    }else{
                        _self.validity[2]=true;
                    }
                    break;
                case 'game-terms':
                    if(!elm[0].checkValidity()){
                        _self.validity[3]=false;
                    }else{
                        _self.validity[3]=true;
                    }
                    break;
                default:
                    break;
            } 
        
            return _self.validity.includes(false)?false:true;
    }
    navigateToRegister():void{
        let _self = this;
        $('#submit-register').click(function(){
            if($('#point-collection-form:visible').length == 0){
                _self.handleRegister();
                return;
            }
            else{
                $('#point-collection-form').hide();
                $('#registration-form>form').fadeIn(1050);
                $(this).addClass('disabled');
            }
        });
    }

    handleRegister():any{
        
        let _self = this;
        let type =  'POST';
        let url = "/bin/services/new/openday/QrCodeGame";
        let mob = $('#mob-register').val();
        
        if(window.location.hostname === 'localhost' && window.location.port == "5000" ){

                type = 'GET';
                url =  "/dummy-data/mhholidayDeals.json";
            
        }


        let data = {
            name: $('#user-name').val(),
            emailId: $('#user-email').val(),
            mobileNumber: mob
        }

        $.ajax({
            // ...parameters,
            type: type,
            url: url,
            data: data,
            success: function (msg: any) {
                
                _self.validity = [false,false, false, false];
                let json: any = null;
                if (typeof msg === 'string') {
                    json = JSON.parse(msg);
                } else {
                    json = msg;
                }				

            
                // successful registration
                $("#registration-success .message").html(json.message);
                _self.createPopup($('#registration-success'), function(){
                    $('#point-collection-form').fadeIn(1050);
                    $('#registration-form>form').hide();
                    $('#submit-register').removeClass('disabled');
                    $("#mob-collect").val(mob).focus();
                });

                //save cookie
                var d = new Date();
                d.setTime(d.getTime() + (3 * 24 * 60 * 60 * 1000));
                var expires = "expires="+d.toUTCString();
                document.cookie="qrc-id="+mob+";"+expires+";path=/";

            },
            error: function (error: any) {
                _self.validity = [false,false, false, false];
                let response: any = null;
                try{
                    response = JSON.parse(error.responseText);

                    if(response.statusCode===409){
                        // number not found
                        _self.createPopup($('#registration-error'));
                    }
                    else{
                        //general error popup
                        _self.createPopup($('#general-error'));
                    }
                }
                catch(e){
                        //general error popup
                        _self.createPopup($('#general-error'));
                        
                }            
            }
    });

    $('#registration-form input').val("");
    $('#registration-form #game-terms').prop('checked', false);
}
    handleCollect():any{

        let _self=this;
        $('#submit-collect').click(function(){
        let mob = _self.mob !==undefined? _self.mob: $('#mob-collect').val();
        let  params = new URLSearchParams(window. location. search);
        let qrname = params.get('QRname');
        let qrurl = $('#qrcode-scan-pagePathID').val();
        let data = {
            'mobileNumber':mob,
            'qrCodeName':qrname,
            'qrCodeScanPagePath': qrurl
        }
            $.ajax({
                type: 'POST',
                url: '/bin/services/new/openday/qrcodescan/collectPoints',
                data: data,
                success: function (msg: any) {
                    

                    let json: any = null;
                    if (typeof msg === 'string') {
                        json = JSON.parse(msg);
                    } else {
                        json = msg;
                    }				
                    
                
                    if(json.statusCode==201){
                        // Successful collection
                        $("#collected-points").html(json.pointsCredited);
                        $("#collect-success .message").html(json.message);
                        $(".total-points ").html(json.totalPointsCollected);
                        _self.createPopup($('#collect-success'));
                        _self.displayProgress(json.data);

                    }
                     //save cookie
                    var d = new Date();
                    d.setTime(d.getTime() + (3 * 24 * 60 * 60 * 1000));
                    var expires = "expires="+d.toUTCString();
                    console.log(d,mob,expires);
                    document.cookie="qrc-id="+mob+";"+expires+";path=/";

                    
                    $('#point-collection-form, #registration-form, #info-section').hide();
                    $('#progression-page').show();
                    $("#qrcode-game-content").show();
                    $("#loader").hide();   

                },
                error: function (error: any) {
                    let response: any = null;
                    
                    try{
                        response = JSON.parse(error.responseText);
                        if(response.statusCode===409){
                            // Already collected points
                            $("#collect-error .message").html(response.errorMessage);
                            $(".total-points").html(response.totalPointsCollected);
                            $('#point-collection-form, #registration-form, #info-section').hide();                    
                            $('#progression-page').show();
                             
                            _self.displayProgress(response.data);
                            _self.createPopup($('#collect-error'));
                        }
                        else if(response.statusCode===404){
                            // invalid number
                            if(response.message==="Invalid User."){
                                _self.createPopup($('#unregistered-error'));
                            }
                            else{
                                _self.createPopup($('#general-error'));
                            }
                            $('#point-collection-form, #registration-form, #info-section').show();  
                        }
                        else if(response.statusCode===425){
                            _self.createPopup($('#event-error'));
                            $('#point-collection-form, #registration-form, #info-section').show();
                        }
                        else{
                            //general error popup
                            _self.createPopup($('#general-error'));
                            $('#point-collection-form, #registration-form, #info-section').show();
                        }
                    }
                    catch(e){
                            //general error popup                            
                            _self.createPopup($('#general-error'));
                            $('#point-collection-form, #registration-form, #info-section').show();  

                                                       
                    }
                    finally{
                        $('#submit-register').removeClass('disabled');
                        $("#mob-collect").val(mob).focus();
                        $("#qrcode-game-content").show();
                        $("#loader").hide();      
                    }
                }
            });
            $('#point-collection-form input').val("");

        })
    }

    createPopup(elm:any, onClose?: any ): void{
        $.magnificPopup.open({
            items: {
                src: '#general-popup'
            },
            type: 'inline',
            midClick: true,
            enableEscapeKey: false,
            showCloseBtn: false,
            closeOnBgClick: false,
            callbacks: {
                beforeOpen: function(){
                    $('#general-popup .content').html(elm.html());
                },
                open: function () {
                    $(".mfp-content").addClass("qrc-popup");
                    if(onClose){
                        $('#general-popup button').click(function(){
                            onClose();
                            $.magnificPopup.close();
                        });
                    }
                    else{
                        $('#general-popup button').click(function(){
                            $.magnificPopup.close();
                        });
                    }
                },
            }
        }, 0);
    }
    getCookie(name:string): any {
        var value = "; " + document.cookie;
        var parts = value.split("; " + name + "=");
        var cookieVal:any;
        if (parts.length == 2) {
            cookieVal = parts.pop().split(";").shift();
            return cookieVal;
        }
    }
    displayProgress(data:any){
        let html = "";

        data.sort(function (a:any,b:any){
            return a.isScanned-b.isScanned;
        });
        for(var i =0; i<data.length;i++){
            let qrName = data[i].qrCodeName;
            let qrStatus = data[i].isScanned? 'Complete':'Not completed';
            let qrClass = data[i].isScanned? 'complete':'incomplete';
            html+=`<li class="${qrClass}" >
            <div class="qr-name">${qrName}</div>
            <div class="qr-status">${qrStatus}</div>
            </li>`;
        }
        $("#progress-chart ul").html(html);
    }
}

let scope:Element = document.querySelector('#qrcode-game-container');
if (scope){
	try {
		let qrCodeGame = new QRcodeGame();
		qrCodeGame.handleCollect();
		qrCodeGame.init();
	} catch(e) {console.error(e);}
}
 